import { SET_BOT_TESTER } from "../constants";

export const setIsOpenBotTester = (bool) => ({
    type: SET_BOT_TESTER,
    payload: bool,
});
